import { LayoutSize, useLayoutContext } from '@/contexts/layout-context';
import { useCallback } from 'react';
import { useExperienceUIStore } from '@experiences/blocs/stores/experience-ui-store';

/**
 * Viewport-aware handler that toggles the correct sidebar state:
 * desktop → `isSidebarCollapsed` in the persisted store.
 * mobile / tablet-portrait → `isMobileDrawerOpen` (transient, in-store).
 *
 * Shared by:
 * - `BaseSidebarTemplate` (top-bar hamburger)
 * - `MicroProductLoaderScreen` (routes the SPA's `SIDEBAR_TOGGLE`
 *   postMessage to the right state)
 */
export function useSidebarToggleHandler(): () => void {
  const { layoutSize } = useLayoutContext();
  const useDrawerLayout =
    layoutSize === LayoutSize.SMALL || layoutSize === LayoutSize.SMALL_TABLET;
  const toggleSidebar = useExperienceUIStore((state) => state.toggleSidebar);
  const toggleMobileDrawer = useExperienceUIStore(
    (state) => state.toggleMobileDrawer,
  );
  return useCallback(() => {
    if (useDrawerLayout) {
      toggleMobileDrawer();
    } else {
      toggleSidebar();
    }
  }, [useDrawerLayout, toggleMobileDrawer, toggleSidebar]);
}
